import { template } from "@ember/template-compiler";
import PathologyFields from '../breast-cancer/pathology-fields';
export default template(`
  {{! @glint-expect-error }}
  <PathologyFields @form={{@form}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
